"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
exports.__esModule = true;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var invoice_action_menu_1 = require("../invoice-components/invoice-action-menu");
var ui_common_1 = require("@codametrix/ui-common");
var confirm_1 = require("../../confirm/confirm");
var ui_common_2 = require("@codametrix/ui-common");
var getValueAtPath = ui_common_2.workBench.pathUtils.getValueAtPath;
// Define the component
var InvoiceMetadatav2 = /** @class */ (function (_super) {
    __extends(InvoiceMetadatav2, _super);
    function InvoiceMetadatav2(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            showRemoveConfirm: false
        };
        return _this;
    }
    InvoiceMetadatav2.prototype.render = function () {
        var _this = this;
        var _a = this.props, editable = _a.editable, invoice = _a.invoice, onInvoiceMetaEdit = _a.onInvoiceMetaEdit, onInvoiceRemove = _a.onInvoiceRemove, fields = _a.fields, _b = _a.idField, idField = _b === void 0 ? 'guid' : _b;
        var handleInvoiceRemove = function (ev) {
            ev.preventDefault();
            var proceedToRemove = ui_common_1.objectUtils.isEmpty(invoice === null || invoice === void 0 ? void 0 : invoice.transactions) ||
                invoice.transactions.every(function (transaction) {
                    return ui_common_1.objectUtils.isEmpty(transaction === null || transaction === void 0 ? void 0 : transaction.codes);
                });
            if (proceedToRemove) {
                if (invoice[idField]) {
                    onInvoiceRemove(invoice[idField]);
                }
            }
            else {
                _this.setState({ showRemoveConfirm: true });
            }
        };
        var handleConfirmRemove = function () {
            if (invoice[idField]) {
                onInvoiceRemove(invoice[idField]);
            }
        };
        var metadataRows = fields
            .map(function (field, index) {
            var value = getValueAtPath(invoice, field.path);
            if (value === undefined || value === null) {
                return null; // Skip empty values
            }
            else if (field.datetimeFormat && value) {
                value = ui_common_2.cmxDateTime.format(value, field.datetimeFormat);
            }
            return ((0, jsx_runtime_1.jsxs)("p", __assign({ className: field.classNames.length > 0 ? field.classNames[0].join(' ') : '' }, { children: [field.displayName && ((0, jsx_runtime_1.jsxs)("span", __assign({ className: "invoice-meta-label" }, { children: [field.displayName, ":"] }))), field.displayName && ' ', value] }), index));
        })
            .filter(function (item) { return item !== null; });
        return ((0, jsx_runtime_1.jsxs)("div", __assign({ className: "invoice-meta-row" }, { children: [(0, jsx_runtime_1.jsx)("div", __assign({ className: "invoice-meta-cell-providers" }, { children: metadataRows })), (0, jsx_runtime_1.jsxs)("div", __assign({ className: "invoice-meta-cell-actions" }, { children: [(0, jsx_runtime_1.jsx)(confirm_1.Confirm, { onConfirm: handleConfirmRemove, onDismiss: function (e) { return _this.setState({ showRemoveConfirm: false }); }, display: this.state.showRemoveConfirm, title: "Are you sure you want to remove this invoice?", strings: {
                                proceed: 'Yes, Remove',
                                dismiss: 'No, Cancel'
                            } }), editable && ((0, jsx_runtime_1.jsx)(invoice_action_menu_1.InvoiceActionMenu, { onEdit: function (e) {
                                e.preventDefault();
                                if (onInvoiceMetaEdit) {
                                    onInvoiceMetaEdit(invoice);
                                }
                            }, onDelete: function (e) {
                                e.preventDefault();
                                if (onInvoiceRemove) {
                                    handleInvoiceRemove(e);
                                }
                            } }))] }))] })));
    };
    return InvoiceMetadatav2;
}(react_1.Component));
exports["default"] = InvoiceMetadatav2;
//# sourceMappingURL=invoice-metadatav2.js.map